{
  "title": "Modèles de signature",
  "subtitle": "Un modèle est un design de signature ; les règles décident qui reçoit lequel.",
  "templates": "Modèles",
  "newTemplate": "Nouveau modèle",
  "loadError": "Impossible de charger les modèles",
  "loadTemplateError": "Impossible de charger le modèle",
  "emptyTitle": "Aucun modèle pour l’instant",
  "emptyBody": "Un modèle est la signature HTML estampillée sur le courrier sortant. Créez-en un pour ouvrir le concepteur.",
  "save": "Enregistrer",
  "publish": "Publier",
  "publishHint": "Compile ce modèle et le met en file pour le courrier sortant. Enregistrer seul ne change pas ce que voient les destinataires.",
  "published": "Publié en v{{version}}. Les signatures se mettront à jour en quelques secondes.",
  "publishFailed": "Échec de la publication.",
  "preview": "Aperçu",
  "undo": "Annuler",
  "redo": "Rétablir",
  "export": "Exporter",
  "exportHint": "Téléchargez ce design en JSON pour l’importer dans un autre modèle ou une autre organisation.",
  "exported": "Modèle exporté.",
  "import": "Importer",
  "importHint": "Remplace le canevas par un design exporté. Enregistrez pour le conserver.",
  "imported": "Design importé. Enregistrez pour le conserver.",
  "importFailed": "Ce fichier n’est pas un modèle de signature valide.",
  "clone": "Dupliquer",
  "cloneHint": "Crée une copie de ce modèle avec le design actuel.",
  "cloned": "Modèle dupliqué.",
  "cloneFailed": "Impossible de dupliquer ce modèle.",
  "cloneNameSuffix": " (copie)",
  "palette": "Blocs",
  "inspector": "Inspecteur",
  "canvas": "Toile",
  "unsaved": "Modifications non enregistrées",
  "unsavedShort": "Non enregistré",
  "checking": "Vérification…",
  "saved": "Modèle enregistré.",
  "saveError": "Impossible d’enregistrer ce modèle.",
  "saveFailed": "Échec de l’enregistrement.",
  "statusDraft": "Brouillon",
  "statusPublished": "Publié",
  "statusArchived": "Archivé",
  "createTitle": "Nouveau modèle",
  "templateName": "Nom du modèle",
  "templateNamePlaceholder": "Corporate — complet",
  "create": "Créer",
  "createError": "Impossible de créer le modèle",
  "blockRow": "Ligne",
  "blockColumn": "Colonne",
  "blockText": "Texte",
  "blockImage": "Image",
  "blockSpacer": "Espaceur",
  "blockDivider": "Séparateur",
  "blockSocial": "Icônes sociales",
  "blockBanner": "Emplacement de bannière",
  "blockButton": "Bouton",
  "blockDisclaimer": "Mention légale",
  "blockGeneric": "Bloc",
  "addRow": "Ajouter une ligne",
  "twoColumns": "Deux colonnes",
  "threeColumns": "Trois colonnes",
  "paletteHelp": "Les colonnes s’ajoutent et se redimensionnent depuis l’inspecteur de la ligne. Une ligne ne peut pas aller dans une colonne — les tableaux imbriqués font échouer le rendu Outlook.",
  "deleteBlock": "Supprimer le bloc",
  "duplicateBlock": "Dupliquer le bloc",
  "noSelection": "Sélectionnez un bloc pour modifier ses propriétés.",
  "content": "Contenu",
  "style": "Style",
  "layout": "Mise en page",
  "previewTitle": "Aperçu",
  "previewAs": "Aperçu en tant que",
  "previewNamed": "Aperçu — {{name}}",
  "previewSignature": "Aperçu de la signature",
  "closePreview": "Fermer l’aperçu",
  "compilerWarnings_one": "{{count}} avertissement du compilateur",
  "compilerWarnings_other": "{{count}} avertissements du compilateur",
  "compilerWarningsHint": "Issu du même compilateur qu’à la publication. Les blocs avec un avertissement sont signalés sur la toile.",
  "sketchBadge": "Esquisse",
  "sketchHint": "Mise en page uniquement — l’espacement, les polices et les particularités Outlook ne sont pas reproduits ici. Ouvrez l’aperçu pour voir le rendu réel du courrier.",
  "canvasEmpty": "Faites glisser un bloc depuis la palette, ou cliquez-en un pour l’ajouter.",
  "emptyColumn": "Colonne vide",
  "reorderRow": "Réordonner la ligne",
  "reorderBlock": "Réordonner {{block}}",
  "markerExternalOnly": "externes uniquement",
  "markerNewMessagesOnly": "nouveaux messages uniquement",
  "markerConditions_one": "{{count}} condition",
  "markerConditions_other": "{{count}} conditions",
  "placeholderImageNoSource": "Image — aucune source",
  "placeholderImageMerge": "Image — source avec champ de fusion",
  "placeholderSocialEmpty": "Icônes sociales — aucune ajoutée",
  "placeholderBanner": "Bannière de campagne — le visuel vient de la campagne active à l’envoi",
  "sampleProfilePhotoAlt": "Photo de profil d’exemple",
  "sampleProfilePhotoTitle": "Photo de profil d’exemple — la vraie photo de chaque expéditeur est utilisée à l’envoi",
  "theme": "Thème",
  "themeHint": "Appliqué à toute la signature. Polices web sûres uniquement — Outlook ne charge pas de police web et Gmail la retire, donc une signature qui en dépend paraît différente pour la plupart des lecteurs.",
  "appliesTo": "S’applique à",
  "font": "Police",
  "baseSizePx": "Taille de base (px)",
  "textColour": "Couleur du texte",
  "linkColour": "Couleur des liens",
  "background": "Arrière-plan",
  "backgroundHint": "Mieux vaut souvent le laisser vide. Les clients en mode sombre recolorent les panneaux clairs, ce qui transforme une signature en boîte blanche dans un fil sombre.",
  "clearBackground": "Effacer l’arrière-plan",
  "maxWidthPx": "Largeur maximale (px)",
  "maxWidthPxHint": "Laissez vide pour Auto — le tableau de signature n’est pas plafonné.",
  "maxWidthBannerHint": "Laissez vide pour Auto — la bannière s’adapte à la largeur de la signature.",
  "hideWhenNoPhoto": "Masquer si l’expéditeur n’a pas de photo",
  "hideWhenBlank": "Masquer si ses champs sont vides",
  "hideWhenNoPhotoHint": "Les photos de profil omettent toujours le portrait (et sa colonne) lorsque l’annuaire n’en a pas — un emplacement vide n’est jamais utile.",
  "hideWhenBlankHint": "Évite qu’un utilisateur sans mobile se retrouve avec un « M: » orphelin et un séparateur isolé.",
  "includeInReplies": "Inclure dans les réponses et transferts",
  "includeInRepliesHint": "Désactivez pour les logos et mentions légales, qui deviennent du bruit au quatrième message d’un fil.",
  "recipients": "Destinataires",
  "audienceEveryone": "Tout le monde",
  "audienceExternalOnly": "Externes uniquement",
  "showOnlyWhen": "Afficher uniquement si",
  "visibleWhenEmptyHint": "Toujours affiché. Ajoutez une condition pour limiter ce bloc à certains utilisateurs.",
  "alignment": "Alignement",
  "alignLeft": "Gauche",
  "alignCentre": "Centre",
  "alignRight": "Droite",
  "paddingTop": "Marge intérieure haute",
  "paddingBottom": "Marge intérieure basse",
  "columns": "Colonnes",
  "columnsHint": "Les colonnes s’ajoutent et se retirent ici plutôt que par glisser-déposer, car une colonne n’a de sens que dans sa ligne.",
  "columnWidth": "Largeur de la colonne {{n}}",
  "placeholderAuto": "Auto",
  "placeholderTheme": "Thème",
  "removeColumn": "Supprimer la colonne {{n}}",
  "editColumn": "Modifier",
  "addColumn": "Ajouter une colonne",
  "widthPx": "Largeur (px)",
  "widthPxHint": "Laissée vide, la colonne partage l’espace restant. Les largeurs fixes survivent mieux au moteur Word que les pourcentages.",
  "verticalAlign": "Alignement vertical",
  "alignTop": "Haut",
  "alignMiddle": "Milieu",
  "alignBottom": "Bas",
  "padLeft": "Marge gauche",
  "padRight": "Marge droite",
  "padTop": "Marge haute",
  "padBottom": "Marge basse",
  "text": "Texte",
  "sizePx": "Taille (px)",
  "lineHeight": "Interligne",
  "colour": "Couleur",
  "bold": "Gras",
  "italic": "Italique",
  "link": "Lien",
  "disclaimerText": "Texte de la mention légale",
  "imageUrl": "URL de l’image",
  "imageUrlHint": "HTTPS absolue, ou {{photoToken}} pour la photo d’annuaire de chaque expéditeur. Gmail n’affiche pas une pièce jointe intégrée, donc les images sont toujours hébergées.",
  "useProfilePhoto": "Utiliser la photo de profil",
  "chooseFromLibrary": "Choisir dans la bibliothèque",
  "clear": "Effacer",
  "profilePhotoHint": "À l’envoi, cela devient la photo de l’expéditeur. Sans photo, le portrait et sa colonne disparaissent entièrement — jamais d’image cassée ni d’espace vide.",
  "heightPx": "Hauteur (px)",
  "unlockAspect": "Déverrouiller le ratio",
  "lockAspect": "Verrouiller le ratio",
  "autoSize": "Auto",
  "autoProfileHint": "Définit {{size}}×{{size}} pour l’emplacement du portrait.",
  "autoNaturalHint": "Utilise la taille naturelle de l’image (plafonnée pour les signatures).",
  "autoNeedSource": "Ajoutez d’abord une URL d’image ou choisissez-en une dans la bibliothèque.",
  "autoNeedHttps": "Auto a besoin d’une URL https:// pour mesurer.",
  "autoMeasureFailed": "Impossible de lire la taille de cette image. Vérifiez que l’URL s’ouvre dans un navigateur.",
  "aspectLocked": "Ratio verrouillé — modifier un côté met l’autre à l’échelle.",
  "aspectUnlocked": "Ratio déverrouillé — largeur et hauteur s’éditent indépendamment.",
  "dimensionsHint": "Les deux dimensions sont émises en attributs HTML. Sans elles, le moteur Word redimensionne l’image sur tout écran au-delà de 96 DPI, soit la plupart.",
  "altText": "Texte alternatif",
  "profilePhotoAlt": "Photo de profil",
  "frame": "Cadre",
  "frameHint": "Bordures et ombres douces apparaissent dans les clients modernes. Outlook classique conserve la bordure et ignore le rayon et l’ombre.",
  "frameColour": "Couleur du cadre",
  "frameNone": "Aucun",
  "frameThin": "Fin",
  "frameThick": "Épais",
  "frameRounded": "Arrondi",
  "frameCircle": "Cercle",
  "frameSoftShadow": "Ombre douce",
  "effect": "Effet",
  "effectHint": "Génère un GIF animé compatible e-mail. Outlook bureau fige souvent sur l’image finale ; Gmail et d’autres clients jouent l’animation.",
  "effectProfileHint": "Les effets nécessitent une image de bibliothèque hébergée ou une URL HTTPS — pas un champ de fusion photo de profil.",
  "effectNeedHttps": "Ajoutez d’abord une image https:// ou choisissez-en une dans la bibliothèque.",
  "effectConverting": "Conversion en GIF animé…",
  "effectApplyFailed": "Impossible d’appliquer cet effet.",
  "effectNone": "Aucun",
  "effectWhipFlip": "Whip Flip",
  "effectDottedGloom": "Dotted Gloom",
  "effectGlowSway": "Glow Sway",
  "effectInvertedChaos": "Inverted Chaos",
  "effectHaloBlur": "Halo Blur",
  "effectBlur": "Blur",
  "effectMirror": "Mirror",
  "effectFadeOut": "Fade Out",
  "effectLowExposure": "Low Exposure",
  "effectColorsOff": "Colors Off",
  "networkPlaceholder": "Réseau",
  "removeIcon": "Supprimer {{name}}",
  "iconFallback": "icône",
  "profileUrl": "URL du profil",
  "profileUrlPlaceholder": "URL du profil — peut être un champ de fusion",
  "iconImageUrl": "URL de l’image d’icône",
  "iconImageUrlPlaceholder": "URL de l’image d’icône",
  "addIcon": "Ajouter une icône",
  "socialIconsHint": "Une icône dont le lien reste vide disparaît d’elle-même, donc un utilisateur sans LinkedIn n’a pas d’icône morte.",
  "platformLabel": "Plateforme",
  "platformLinkedIn": "LinkedIn",
  "platformX": "X",
  "platformFacebook": "Facebook",
  "platformInstagram": "Instagram",
  "platformYouTube": "YouTube",
  "platformTikTok": "TikTok",
  "platformThreads": "Threads",
  "platformGitHub": "GitHub",
  "platformWhatsApp": "WhatsApp",
  "platformWebsite": "Site web",
  "platformOther": "Autre",
  "chooseIconFromLibrary": "Choisir une icône dans la bibliothèque",
  "useDefaultIcon": "Utiliser l’icône par défaut",
  "iconOverrideHint": "Laissez vide seulement pour Autre sans image. Les défauts sont des URL HTTPS du produit.",
  "iconAlt": "Texte alternatif",
  "moveIconUp": "Déplacer l’icône vers la gauche",
  "moveIconDown": "Déplacer l’icône vers la droite",
  "iconMustBeHttps": "L’image d’icône doit être une URL https:// pour apparaître dans le courrier.",
  "spacingPx": "Espacement (px)",
  "bannerSlotHint": "Le visuel et le lien viennent de la campagne active à l’envoi, pour que le marketing démarre et arrête une bannière sans rouvrir ce modèle.",
  "label": "Libellé",
  "url": "URL",
  "buttonWidth": "Largeur",
  "buttonHeight": "Hauteur",
  "cornerRadius": "Rayon des coins",
  "fontSize": "Taille de police",
  "thicknessPx": "Épaisseur (px)",
  "dividerHint": "Dessiné comme une cellule de tableau remplie plutôt qu’un hr, que les clients stylent de façon inconsistante.",
  "insertField": "Insérer un champ",
  "searchFields": "Rechercher des champs",
  "noFieldMatch": "Aucun champ ne correspond.",
  "mergeFieldProblem": "Problème de champ de fusion",
  "emptyText": "Texte vide",
  "groupThisTenant": "Ce locataire",
  "groupUser": "Utilisateur",
  "groupOrganisation": "Organisation",
  "groupCampaign": "Campagne",
  "fieldDisplayName": "Nom d’affichage",
  "fieldGivenName": "Prénom",
  "fieldSurname": "Nom",
  "fieldJobTitle": "Titre du poste",
  "fieldDepartment": "Service",
  "fieldPrimaryEmail": "Adresse e-mail",
  "fieldPhotoUrl": "Photo de profil (URL d’image)",
  "fieldMobilePhone": "Mobile",
  "fieldBusinessPhone": "Téléphone",
  "fieldOfficeLocation": "Bureau",
  "fieldCity": "Ville",
  "fieldCountry": "Pays",
  "fieldTenantName": "Nom de l’organisation",
  "fieldTenantSlug": "Identifiant de l’organisation",
  "fieldCampaignAlt": "Texte alternatif de la bannière",
  "fieldCampaignUrl": "Lien de la bannière",
  "dirtyPreviewTitle": "Affichage de la dernière version enregistrée",
  "dirtyPreviewBody": "L’aperçu affiche ce qui est stocké, pas ce qui est sur la toile. Enregistrez pour le rafraîchir.",
  "desktopWidth": "Bureau 600px",
  "mobileWidth": "Mobile 320px",
  "darkMode": "Mode sombre",
  "darkModeTooltip": "Approximation seulement : les couleurs sont inversées et pivotées, ce qu’aucun client réel ne fait. Outlook, Gmail et Apple Mail recolorent différemment et certains laissent les fonds clairs. Utilisez-le pour repérer une signature qui disparaît, pas pour valider les couleurs.",
  "darkModeHint": "Approximatif. Les vrais clients recolorent autrement — traitez-le comme un test rapide, pas une preuve.",
  "renderWarnings": "Avertissements de rendu",
  "renderError": "Impossible de rendre l’aperçu",
  "iframeTitle": "Aperçu de la signature — {{context}}",
  "contextNew": "Nouveau",
  "contextReply": "Réponse",
  "contextNewExternal": "Nouveau (externe)",
  "contextReplyExternal": "Réponse (externe)",
  "contextGmail": "Gmail",
  "contextAddIn": "Complément",
  "contextPlainText": "Texte brut",
  "testAs": "Tester en tant que",
  "testAsHint": "Les champs de fusion et la photo viennent de cette boîte. Effacez pour utiliser la personne d’exemple.",
  "loadingMailboxes": "Chargement des boîtes…",
  "samplePerson": "Personne d’exemple",
  "noMailboxMatch": "Aucune boîte ne correspond à cette recherche.",
  "selectedMailbox": "Boîte sélectionnée",
  "excludedSuffix": " (exclu)",
  "gmailBudget": "Budget de taille Gmail",
  "gmailCharacters": "{{used}} / {{max}} caractères",
  "gmailWillTruncate": "Gmail tronquera",
  "gmailNearLimit": "Proche de la limite",
  "assetPickerTitle": "Choisir une image",
  "assetPickerHint": "Images hébergées, récupérées par le client de messagerie du destinataire. PNG, JPEG, GIF ou WebP.",
  "uploadImage": "Téléverser une image",
  "uploadWarningTitle": "Téléversée, mais à vérifier",
  "assetsEmpty": "Aucune image pour l’instant. Téléversez-en une et elle apparaîtra ici pour chaque signature de ce locataire.",
  "alreadyInLibrary": "Cette image était déjà dans la bibliothèque, donc l’existante a été utilisée.",
  "uploadFailed": "Impossible de téléverser cette image.",
  "deleteFailedTitle": "Non supprimée",
  "deleteFailed": "Impossible de supprimer cette image.",
  "deleteAsset": "Supprimer {{name}}",
  "useThisAsset": "Utiliser celle-ci"
}
